<template>
    <div>
        <div class="container" style="width:100%;">
            <div style="font-size:20px;"><i class="el-icon-s-unfold grid-con-icon"></i><span style="margin-left:5px;">订单信息</span></div>
            <el-form :model="form" inline  style="padding-left:8px;margin-top:-20px;">
                <div style="display:flex;justify-content:flex-end;">
                    <el-button @click="onImportClick" type="primary">导入订单</el-button>
                </div>
                <!-- justify="space-between" -->
                <el-row  type="flex" style="margin-top:15px;" align="center">
                    <el-form-item label="数据日期" style="width: 500px;">
                            <el-date-picker
                                    v-model="form.dateArray"
                                    type="daterange"
                                    range-separator="至"
                                    value-format="yyyy-M-d"
                                    start-placeholder="年/月/日"
                                    end-placeholder="年/月/日">
                            </el-date-picker>
                    </el-form-item>
                    <el-switch
                        v-model="form.isValidDate"
                        active-text="按生效日期"
                        inactive-text="按订单日期">
                    </el-switch>
                    
                </el-row>
                <el-row>
                    <el-form-item label="订单状态">
                        <el-select v-model="form.statusIdsArr" clearable multiple  placeholder="请选择">
                            <el-option v-for="item in orderStatusList" :key="item.value" :label="item.label"
                                :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="产品">
                        <el-select v-model="form.productArr" clearable multiple  placeholder="请选择">
                            <el-option v-for="item in productList" :key="item.value" :label="item.label"
                                :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="关键字">
								<el-input v-model="form.key" class="text-width"></el-input>
					</el-form-item>
                    <!--  -->
                    <el-button @click="onQuery" type="primary">检索</el-button>
                </el-row>
            </el-form>
            <el-table 
                :data="orderList.slice((currentPage-1)*PageSize,currentPage*PageSize)" 
                border :header-cell-style="{background:'#eef1f6',color:'#606266'}" height="800"
                        style="width: 80%;margin-top: 10px;" ref="Table" >
                <el-table-column prop="订单编号" align="center" width="130" label="订单编号">
                    <!-- <template slot-scope="scope" >
                         <div :style="{'color':scope.row.delay==1 && scope.row.roleId==1?'red':'black'}">{{scope.row.sheetCode}}</div>
                    </template> -->
                </el-table-column>
                <!-- <el-table-column :key="Math.random()" prop="comeFrom" align="center" width="50" label="来源"></el-table-column> -->
                <el-table-column prop="订单日期" align="center" width="110" label="订单日期" >
                    <template slot-scope="scope" >
                         {{scope.row.订单日期.split('T')[0]}}
                    </template>
                </el-table-column> 
                <el-table-column prop="经销商简称" align="center" label="经销商简称" ></el-table-column> 
                <el-table-column prop="终端客户" align="center"  label="终端客户" ></el-table-column>
                <el-table-column prop="产品名称" align="center" label="产品名称" ></el-table-column>
                <el-table-column prop="数量" align="center" width="80" label="数量" ></el-table-column>
                <el-table-column prop="预约开通日" align="center" width="110" label="预约开通日" >
                    <template slot-scope="scope" >
                         {{scope.row.预约开通日=='1900-01-01T00:00:00'?'':scope.row.预约开通日.split('T')[0]}}
                    </template>
                </el-table-column>
                <el-table-column prop="预约关闭日" align="center" width="110" label="预约关闭日" >
                    <template slot-scope="scope" >
                         {{scope.row.预约关闭日=='1900-01-01T00:00:00'?'':scope.row.预约关闭日.split('T')[0]}}
                    </template>
                </el-table-column>
                <el-table-column prop="订单状态" align="center" width="80" label="订单状态" ></el-table-column>
                <!-- <el-table-column prop="alertValue" align="center"  width="50" label="紧急程度" >
                    <template slot-scope="scope" >
                         <div :style="{'color':scope.row.alertValue=='紧急'?'red':'#333'}">{{scope.row.alertValue}}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="statusName" align="center" width="77" label="工单状态" >
                    <template slot-scope="scope" >
                         <div :style="{'color':scope.row.statusName=='已结单'?'green':(scope.row.statusName=='已关闭'?'red':'#E58505')}">{{scope.row.statusName}}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="rowTime" align="center" width="100" label="创建时间" ></el-table-column>
                <el-table-column  v-if="canNew" prop="dealLength" align="center" width="77" label="处理时长"></el-table-column>
                <el-table-column  align="center" label="操作" >
                    <template slot-scope="scope">
                    <el-button-group>
                        <el-button type="primary" size="small"
                        @click.native.prevent="onItemEditClick(scope.row,1)"
                    >{{scope.row.statusName=='已结单'?'查看':'跟进'}}</el-button>
                    <el-button v-if="canNew && scope.row.statusName!=='已结单' && scope.row.statusName!=='已关闭'" type="warning" size="small"
                        @click.native.prevent="onItemCloseClick(scope.row)"
                    >关闭</el-button>
                    <el-button v-if="canNew && scope.row.statusName!=='已结单' && scope.row.statusName!=='已关闭' && scope.row.haveReply==1" type="danger" size="small"
                        @click.native.prevent="onItemFinishClick(scope.row)"
                    >结单</el-button>
                    <el-button v-if="scope.row.isManager==1 && scope.row.statusName=='已结单' && scope.row.haveReply==1" type="danger" size="small"
                        @click.native.prevent="onItemSetTimeClick(scope.row)"
                    >调整</el-button>
                        <el-button v-if="scope.row.roleId=='1'" :type="scope.row.satisfyRemark?'primary':'danger'" size="small"
                        @click.native.prevent="onItemSetRemarkClick(scope.row,1)">满意度说明</el-button>
                        <el-button v-if="scope.row.roleId=='1'" :type="scope.row.visitRemark?'primary':'danger'" size="small"
                        @click.native.prevent="onItemSetRemarkClick(scope.row,2)">回访说明</el-button>
                        <el-button v-if="scope.row.roleId=='1'" :type="scope.row.remark?'primary':'info'" size="small"
                        @click.native.prevent="onItemSetRemarkClick(scope.row,3)">备注</el-button>
                    </el-button-group>

                    
            
                    </template>
                </el-table-column> -->
                </el-table>

                <div class="tabListPage">
                    <el-pagination @size-change="handleSizeChange" 
                                    @current-change="handleCurrentChange" 
                                    :current-page="currentPage" 
                                    :page-sizes="pageSizes" 
                                    :page-size="PageSize" layout="total, sizes, prev, pager, next, jumper" 
                                    :total="totalCount">
                        </el-pagination>
                </div>
            <!-- <el-form :model="form" inline  style="padding-left:8px;padding-top:8px;">
						

						<br>
						<el-form-item label="选择数据源">
								<el-upload
										class="upload-demo"
										ref="upload"
										action="string"
										:http-request="uploadFile"
										:auto-upload="false">
										<el-button slot="trigger" size="small" type="primary">选取文件</el-button>
										<el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">上传</el-button>
								</el-upload>
						</el-form-item>
				</el-form> -->
            <el-dialog title="导入订单" :visible="importDialogVisible" width="60%"
                            :modal-append-to-body='false'
                            :close-on-click-modal='false'
                            @close="importDialogVisible = false" 
                            append-to-body>
                <el-form :model="importForm" inline style="margin-top: 30px;">
                    <el-row>
                        <el-form-item label="选择订单Excel文件">
                                <el-upload
                                        class="upload-demo"
                                        ref="upload"
                                        action="string"
                                        :http-request="uploadFile"
                                        :auto-upload="false">
                                        <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                                        <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">上传</el-button>
                                </el-upload>
                        </el-form-item>
                    </el-row>                                         
            </el-form>
            <div v-if="importLog.length>0">
                <el-divider content-position="left">订单数量变化情况</el-divider>
                <el-table 
                    :data="importLog" 
                    border :header-cell-style="{background:'#eef1f6',color:'#606266'}" 
                    @selection-change="handleSelectionChange"
                    ref="logTable"
                    :row-key="getRowKey"    
                    style="width: 80%;margin-top: 10px;" >
                    <el-table-column type="selection" reserve-selection width="55"></el-table-column>	
                    <el-table-column prop="终端客户" align="center"  label="终端客户"></el-table-column>
                    <el-table-column prop="已入库记录数" align="center" label="已入库订单数"></el-table-column>
                    <el-table-column prop="新记录数" align="center" label="新订单数" >
                        <template slot-scope="scope" >
                            <span :style="scope.row.已入库记录数!==scope.row.新记录数?'color:red':''">{{scope.row.新记录数}}</span>
                        </template>
                    </el-table-column>                
                </el-table>
                <el-divider content-position="left">变化日志</el-divider>
                <el-table v-if="importLog.length>0"
                    :data="importMsg" 
                    border :header-cell-style="{background:'#eef1f6',color:'#606266'}" 
                            style="width: 80%;margin-top: 10px;" >
                    <el-table-column prop="newMsg" align="center"  label="新订单情况"></el-table-column>
                    <el-table-column prop="changeMsg" align="center" label="订单调整情况">
                        <template slot-scope="scope" >
                            
                                <p v-html="scope.row.changeMsg.split('/r/n').map(item => `<p>${item}</p>`).join('')" style="text-align: left;"></p>
                            
                        </template>
                    </el-table-column>                             
                </el-table>


                <div slot="footer" style="display:flex;justify-content:center;margin-top:5px;">
                    <el-button @click="importDialogVisible = false">关闭</el-button>
                    <el-button style="margin-left:20px;" type="primary" @click="onSaveImport">保存</el-button>
                </div>
            </div>
		</el-dialog>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getLatestMonthDateArrayByDate } from "@/utils/time";
import { getToken } from "@/utils/auth";
// import {uploadFile} from "@/api/file";
import {ZC_Import} from "@/api/zc";


export default {
    name: 'baseform',
    components: {

      },
    computed: {
        ...mapGetters(['orderStatusList','productList','orderList','importOrderExcel'])
    },
    data() {
        return {
            form: {    
                dateArray:getLatestMonthDateArrayByDate({date:new Date(),delayNum:1, formatValue: 'yyyy-MM-dd'}),
                isValidDate:true,
                statusIdsArr:[],
                productArr:[],
                key:'',
            },
            props: { multiple: true },

            // 默认显示第几页
            currentPage:1,
            // 总条数，根据接口获取数据长度(注意：这里不能为空)
            totalCount:0,
            // 个数选择器（可修改）
            pageSizes:[20,50,100],
            // 默认每页显示的条数（可修改）
            PageSize:50,

            importDialogVisible:false,
            importForm:{},
            importLog:[],            
            importMsg:[],
            importNo:0,
            selectedList:[],
        };
    },

    async mounted() {
        await this.$store.dispatch('zc/orderStatusList');
        await this.$store.dispatch('zc/productList');
        this.onQuery();
    },


    methods: {
        async onImportClick(){
            this.importForm={};
            this.importLog=[];          
            this.importMsg=[];
            this.importNo=0;
            this.importDialogVisible=true;
        },

       async onQuery(){
        console.log('form',this.form)
        const {dateArray:[sDate, eDate],isValidDate,statusIdsArr,productArr,key} = this.form;
        var statusIds='';
        var productIds='';
        if (statusIdsArr.length>0){
            statusIds=statusIdsArr.join(',');
        }
        if (productArr.length>0){
            productIds=productArr.join(',');
        }
        // console.log('aa',sDate,eDate,this.productSearchForm);
        await this.$store.dispatch("zc/orderList", {
            sDate,
            eDate,
            statusIds,
            productIds,
            isValidDate,
            key,
        }).then(res=>{
            this.$refs.Table.doLayout();
            this.totalCount=this.orderList.length
            this.currentPage=1
            
        });

       },

       // 每页显示的条数
        handleSizeChange(val) {
        // 改变每页显示的条数 
        this.PageSize=val
        // 注意：在改变每页显示的条数时，要将页码显示到第一页
        this.currentPage=1
        },
        // 显示第几页
        handleCurrentChange(val) {
            // 改变默认的页数
            this.currentPage=val
        },

        async uploadFile(param) {
            console.log('param',param);
            const formData = new FormData()
            formData.append('fileInfo', param.file);
            const loading = this.$loading({
                lock: true,
                text: '读取中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });


            // const {dateArray: [sDate, eDate], title} = this.form, {file: {name: fileName}} = param;
            await this.$store.dispatch("zc/importOrderExcel", {
                formData
            }).then(res=>{
                // this.$refs.Table.doLayout();
                // this.totalCount=this.orderList.length
                // this.currentPage=1
                this.importLog = this.importOrderExcel[0];
                this.importMsg = this.importOrderExcel[1];
                this.importNo = this.importOrderExcel[2][0].importNo;
                loading.close();
                this.$message.success('读取成功');
            }).catch(error => {
                loading.close();
            })
            // await ImportOrderExcel({userId: getToken(),formData});
            // this.$message.success('上传成功');
            // await this.$store.dispatch('dataInterface/DataInterfaceList');
        },

        submitUpload() {
            this.$refs.upload.submit();
        },

        getRowKey(row) {
            return row.终端客户;
        },

        handleSelectionChange(val) {	
            this.selectedList = val;				
        },
        
        async onSaveImport(){
            var company='';
            this.selectedList.forEach(element => {
                if (company==''){
                    company = element.终端客户;
                }else{
                    company = company+','+element.终端客户;
                }

            });    
            await ZC_Import({userId: getToken(),company,importNo:this.importNo}).then(()=>{
                this.onQuery();
                this.$message.success('导入成功');
                this.importDialogVisible=false;
            });
        },
    }
};
</script>

<style scoped>
</style>